export const FETCH_SITE_IMAGES_START = 'FETCH_SITE_IMAGES_START';
export const FETCH_SITE_IMAGES_SUCCESS = 'FETCH_SITE_IMAGES_SUCCESS';
export const FETCH_SITE_IMAGES_FAIL = 'FETCH_SITE_IMAGES_FAIL';

export const UPDATE_SITE_IMAGE_START = 'UPDATE_SITE_IMAGE_START';
export const UPDATE_SITE_IMAGE_SUCCESS = 'UPDATE_SITE_IMAGE_SUCCESS';
export const UPDATE_SITE_IMAGE_FAIL = 'UPDATE_SITE_IMAGE_FAIL';

export const UPDATE_SITE_IMAGE_CTA_START = 'UPDATE_SITE_IMAGE_CTA_START';
export const UPDATE_SITE_IMAGE_CTA_SUCCESS = 'UPDATE_SITE_IMAGE_CTA_SUCCESS';
export const UPDATE_SITE_IMAGE_CTA_FAIL = 'UPDATE_SITE_IMAGE_CTA_FAIL';

export const DELETE_SITE_IMAGE_START = 'DELETE_SITE_IMAGE_START';
export const DELETE_SITE_IMAGE_SUCCESS = 'DELETE_SITE_IMAGE_SUCCESS';
export const DELETE_SITE_IMAGE_FAIL = 'DELETE_SITE_IMAGE_FAIL';

export const RESET_SITE_IMAGE_STORE = 'RESET_SITE_IMAGE_STORE';

export const LOGOUT = 'LOGOUT';

export type SiteImageActionTypes =
  | typeof FETCH_SITE_IMAGES_START
  | typeof FETCH_SITE_IMAGES_SUCCESS
  | typeof FETCH_SITE_IMAGES_FAIL
  | typeof UPDATE_SITE_IMAGE_START
  | typeof UPDATE_SITE_IMAGE_SUCCESS
  | typeof UPDATE_SITE_IMAGE_FAIL
  | typeof UPDATE_SITE_IMAGE_CTA_START
  | typeof UPDATE_SITE_IMAGE_CTA_SUCCESS
  | typeof UPDATE_SITE_IMAGE_CTA_FAIL
  | typeof DELETE_SITE_IMAGE_START
  | typeof DELETE_SITE_IMAGE_SUCCESS
  | typeof DELETE_SITE_IMAGE_FAIL
  | typeof RESET_SITE_IMAGE_STORE
  | typeof LOGOUT;
